/**
 * Fix lépésközű játékhurok akkumulátorral.
 *
 * Miért fix: a változó lépésköz nem determinisztikus, és a gyors mozgás
 * ütközésdetektálását keretidő-függővé teszi — 144 Hz-en más játék lenne,
 * mint 30-on. A renderelés ettől függetlenül fut, interpolációval.
 *
 * Gazda: C
 */

import { TICK_DT } from './contracts'

/** Egy kereten belül ennyi pótlépést engedünk, utána eldobjuk a maradékot. */
const MAX_STEPS = 5

export class GameLoop {
  private accumulator = 0
  private lastTime = 0
  private rafId = 0
  private running = false

  /** Az utolsó mért, simított keretidő (mp) — a HUD-hoz. */
  smoothedFrameTime = 1 / 60

  constructor(
    private readonly fixedUpdate: () => void,
    private readonly render: (alpha: number, dtReal: number) => void,
  ) {}

  start(): void {
    if (this.running) return
    this.running = true
    this.lastTime = performance.now()
    this.accumulator = 0
    const frame = (now: number) => {
      if (!this.running) return
      this.rafId = requestAnimationFrame(frame)

      let dtReal = (now - this.lastTime) / 1000
      this.lastTime = now
      // Nagyon nagy ugrás (háttértab, breakpoint): inkább eldobjuk.
      if (dtReal > 0.25) dtReal = TICK_DT
      this.smoothedFrameTime += (dtReal - this.smoothedFrameTime) * 0.08

      this.accumulator += dtReal
      let steps = 0
      while (this.accumulator >= TICK_DT && steps < MAX_STEPS) {
        this.fixedUpdate()
        this.accumulator -= TICK_DT
        steps++
      }
      // Spirál-of-death elleni védelem: ha nem tudtunk felzárkózni,
      // a felgyűlt időt elengedjük, nem halmozzuk tovább.
      if (steps === MAX_STEPS) this.accumulator = 0

      this.render(this.accumulator / TICK_DT, dtReal)
    }
    this.rafId = requestAnimationFrame(frame)
  }

  stop(): void {
    this.running = false
    cancelAnimationFrame(this.rafId)
  }

  get fps(): number {
    return 1 / Math.max(1e-4, this.smoothedFrameTime)
  }
}
